<template>
  <section>
    <div style="height:280px;background-color: #fff;" id="footerSection" ></div>
    <div class="div-block-446">
      <div class="div-block-1672"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-6"></div>
      <!--<div class="div-block-1784">
        <a href="#" class="link-block-67 w-inline-block"><img src="@/assets/images/icon_ig.svg" loading="lazy" alt=""></a>
        <a href="#" class="link-block-67 w-inline-block"><img src="@/assets/images/icon_fb-cntered.svg" loading="lazy" alt=""></a>
        <a href="#" class="link-block-67 w-inline-block"><img src="@/assets/images/icon_x.svg" loading="lazy" alt=""></a>
      </div>-->
      <div class="div-block-447">
        <div class="div-block-980">
          <div class="div-block-1789">
            <a href="https://newself.com/hipaa" target="_blank" class="link-10">HIPAA Notice</a>
            <a href="https://newself.com/privacy-policy" target="_blank" class="link-10">Privacy Policy</a>
            <a href="https://newself.com/returns-and-refund" target="_blank" class="link-10">Returns &amp; Refund Policy</a>
            <a href="https://newself.com/terms-of-use" target="_blank" class="link-10">Terms Of Use</a>
            <a href="https://newself.com/sms-terms-conditions" target="_blank" class="link-10">SMS Terms & Conditions</a>
          </div>
          <div class="div-block-1790">
            <a href="https://newself.com/ccpa" target="_blank" class="link-10">CCPA Opt-Out</a>
            <a href="https://www.newself.com/partner" target="_blank" class="link-10">Partner Information</a>
            <a href="https://newself.com/telehealth-consent" target="_blank" class="link-10">Tele Health Consent</a>
            <a href="https://newself.com/safety" target="_blank" class="link-10">Safety</a>
            <a href="https://help.newself.com/" target="_blank" class="link-10">Help Center</a>
          </div>
        </div>
      </div>
      <div class="div-block-1671">
        <p class="paragraph-125"><strong>NewSelf </strong>is a technology platform that collaborates with independent healthcare professionals to deliver top-notch services through our <strong>NewSelf Patient Management System</strong>. We do not directly offer medical or pharmacy services, and payment does not guarantee that a prescription will be written or medication dispensed. Independent providers handle all medical services. The information provided on this site is for informational purposes only and is not a substitute for professional medical advice. For any health-related concerns, please consult your licensed healthcare provider. Our platform serves as an advertisement for services, not for specific medications.<br>‍<br><strong>Disclaimer:</strong> The FDA-approved brand-name drugs, such as <strong>Wegovy®</strong> and <strong>Ozempic®</strong>, are exclusively available from <strong>Novo Nordisk®</strong>. <strong>Mounjaro®</strong> and <strong>Zepbound®</strong> are exclusively available from <strong>Eli Lilly and Company®</strong>. <strong>NewSelf </strong>does not claim any affiliation with, or endorsement from, the above-mentioned products or entities.<br></p>
      </div>
      <div class="div-block-1791">
        <div class="div-block-1783">
          <div class="text-block-855">NewSelf<br>{{getAddressLine1}}<br>{{getAddressLine2}}</div>
        </div><img src="@/assets/images/Image-from-iOS-1-Photoroom.webp" loading="lazy" alt="" class="image-423"><img src="@/assets/images/Hippa-blue.svg" loading="lazy" alt="" class="image-424">
        <div class="w-embed">
          <a href="https://www.legitscript.com/websites/?checker_keywords=newself.com" target="_blank" title="Verify LegitScript Approval for www.newself.com">
            <img src="https://static.legitscript.com/seals/43278346.png" alt="Verify Approval for www.newself.com" class="ligit-logo">
          </a>
        </div>
      </div>
      <div class="footer-div-5">
        <div class="text-block-1479">© {{getYear}} Newself. All rights reserved.</div>
        <div class="footer-div2-right"><img loading="lazy" src="@/assets/images/icon_card_visa_1icon_card_visa.webp" alt="" class="image-608"><img loading="lazy" src="@/assets/images/icon_card_mastercard_1icon_card_mastercard.webp" alt="" class="image-608"><img loading="lazy" src="@/assets/images/icon_card_amex_1icon_card_amex.webp" alt="" class="image-608"></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name: 'footerComponent',
    data() {
        return {

        }
    },
    computed: {
        getYear() {
            return new Date().getFullYear();
        },
    getAddressLine1(){
      return process.env.VUE_APP_COMPANY_ADDRESS
    },
    getAddressLine2(){
      return `${process.env.VUE_APP_COMPANY_CITY}, ${process.env.VUE_APP_COMPANY_STATE_ZIP}`
    },
    },

}
</script>
<style>
.ligit-logo{
  width: 73px;
  height: 79px;
}
@media screen and (max-width: 479px) {
  .ligit-logo{
    width: 70px;
    height: 65px;
  }
}
</style>
